/**
 * geo-detect.js
 *
 * Определяет страну пользователя через ipapi.co.
 * Результат сохраняется в localStorage('userGeolocation') для повторных посещений.
 * После определения диспатчит событие `geo:ready` с { countryCode }.
 * Другие скрипты могут подписаться на это событие или читать из localStorage.
 */

(function () {
  const GEO_KEY = 'userGeolocation';
  const GEO_NAME_KEY = 'userGeolocationName';
  const GEO_POST_KEY = 'userPostCode';
  const API_URL = 'https://ipapi.co/json/?key=K03xOHk9lT8QTYh2jPTSWC3xlWRINTnl1411kyUjFwlWGHIYnE';

  function dispatchGeoReady(countryCode) {
    if (!window.Shopify) window.Shopify = {};
    if (!window.Shopify.geo) window.Shopify.geo = {};
    window.Shopify.geo.countryCode = countryCode;

    document.dispatchEvent(
      new CustomEvent('geo:ready', { detail: { countryCode } })
    );
  }

  async function detectGeo() {
    // Быстрый путь: уже сохранено в localStorage
    let cached = null;
    try {
      cached = localStorage.getItem(GEO_KEY);
    } catch (_) { /* private browsing mode */ }

    if (cached) {
      dispatchGeoReady(cached);
      return;
    }

    // Запрашиваем API
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      const code = data.country_code || '';

      try {
        localStorage.setItem(GEO_KEY, code);
        localStorage.setItem(GEO_NAME_KEY, data.country_name || '');
        localStorage.setItem(GEO_POST_KEY, data.postal || '');
      } catch (_) { /* ignore storage errors */ }

      dispatchGeoReady(code);
    } catch (err) {
      console.warn('[geo-detect] Failed to detect location:', err);
      // Диспатчим с пустым кодом, чтобы фильтр всё равно запустился
      dispatchGeoReady('');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectGeo);
  } else {
    detectGeo();
  }
})();
